const pccxy = r => require.ensure([], () => r(require('../../views/interfacemanagement/views/pccxy/pccxy.vue')), 'pccxy')
const secondarycheck = r => require.ensure([], () => r(require('../../views/interfacemanagement/views/secondarycheck/secondarycheck.vue')), 'secondarycheck')
const U8interfacemangement = r => require.ensure([], () => r(require('../../views/interfacemanagement/views/U8interfacemangement/U8interfacemangement.vue')), 'U8interfacemangement')
const LeftviweChildrenRouter = [
    {
        path: '/Helper/CheckInvoiceDemo',
        name: 'pccxy',
        component: pccxy,
        meta: {
            typePage: 2
        }
    },
    {
        path: '/Helper/Check2Invoice',
        name: 'secondarycheck',
        component: secondarycheck,
        meta: {
            typePage: 2
        }
    },
    {
        path: '/Helper/U8Synchronous',
        name: 'U8interfacemangement',
        component: U8interfacemangement,
        meta: {
            typePage: 2
        }
    },
];
export default LeftviweChildrenRouter
